import { Monitor, Smartphone, LogOut, ArrowLeft } from "lucide-react";
import { Button } from "./ui/button";

// Shown when a page is restricted to desktop/laptop. Two modes:
//  - full (default): whole-app block with logout.
//  - pageOnly: a single heavy page (reports/COA/backup) is desktop-only; the
//    rest of the app stays usable on mobile, so we offer a "back" action.
export default function DeviceBlock({ showLogout = true, pageOnly = false }) {
  const logout = () => {
    try { localStorage.removeItem("token"); } catch (e) { /* ignore */ }
    window.location.href = "/login";
  };
  const goHome = () => { window.location.href = "/admin/dashboard"; };

  const wrapClass = pageOnly
    ? "flex min-h-[70vh] items-center justify-center bg-slate-50 px-6 text-center"
    : "fixed inset-0 z-[9999] flex items-center justify-center bg-slate-950 px-6 text-center";

  return (
    <div data-testid={pageOnly ? "device-block-page" : "device-block-screen"} className={wrapClass}>
      <div className="max-w-md">
        <div className="relative mx-auto mb-8 flex h-24 w-24 items-center justify-center">
          <span className={`absolute inset-0 rounded-2xl ${pageOnly ? "bg-slate-200" : "bg-emerald-500/10"}`} />
          <Monitor className={pageOnly ? "relative text-slate-600" : "relative text-emerald-400"} size={44} strokeWidth={1.5} />
          <span className="absolute -bottom-2 -right-2 flex h-9 w-9 items-center justify-center rounded-full border-2 border-slate-950 bg-rose-500">
            <Smartphone className="text-white" size={16} />
          </span>
        </div>

        <h1 className={`font-display text-2xl font-bold tracking-tight ${pageOnly ? "text-slate-900" : "text-white"}`}>
          {pageOnly ? "Halaman Ini Hanya di Komputer" : "Akses Hanya via Komputer / Laptop"}
        </h1>
        <p className={`mt-3 text-sm leading-relaxed ${pageOnly ? "text-slate-500" : "text-slate-400"}`}>
          {pageOnly ? (
            <>Halaman ini berisi tabel &amp; laporan rinci yang paling nyaman dibuka di layar lebar. Silakan buka lewat <strong className="text-slate-700">komputer atau laptop</strong>. Menu lain tetap bisa digunakan di HP.</>
          ) : (
            <>Demi keamanan &amp; kenyamanan operasional, aplikasi ini <strong className="text-slate-200">tidak dapat diakses melalui smartphone atau tablet</strong>. Silakan buka kembali menggunakan komputer atau laptop.</>
          )}
        </p>

        <div className="mt-8">
          {pageOnly ? (
            <Button onClick={goHome} data-testid="device-block-home" className="h-11 w-full bg-slate-900 text-white hover:bg-slate-800">
              <ArrowLeft size={16} className="mr-2" /> Kembali ke Beranda
            </Button>
          ) : showLogout && (
            <>
              <Button onClick={logout} data-testid="device-block-logout" className="h-11 w-full bg-emerald-600 text-white hover:bg-emerald-700">
                <LogOut size={16} className="mr-2" /> Keluar / Logout
              </Button>
              <p className="mt-3 text-xs text-slate-500">
                Sesi Anda akan diakhiri. Login kembali dari komputer atau laptop.
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
